import { render, staticRenderFns } from "./CurrentLpo__resultTableMzl.vue?vue&type=template&id=4742e28d&scoped=true&"
import script from "./CurrentLpo__resultTableMzl.vue?vue&type=script&lang=js&"
export * from "./CurrentLpo__resultTableMzl.vue?vue&type=script&lang=js&"
import style0 from "@/style/tables.scss?vue&type=style&index=0&id=4742e28d&lang=scss&scoped=true&"
import style1 from "./CurrentLpo__resultTableMzl.vue?vue&type=style&index=1&id=4742e28d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4742e28d",
  null
  
)

export default component.exports